import type { ReactNode } from 'react';
import { Stack, Text, Box } from '@nike/podium';
import ErrorBoundary from './ErrorBoundary';

interface LayoutProps {
  children: ReactNode;
}

export default function Layout({ children }: LayoutProps) {
  return (
    <>
      <nav
        style={{
          position: 'fixed',
          top: 0,
          width: '100%',
          zIndex: 1000,
          backgroundColor: 'var(--pds-color-black)',
        }}
      >
        <Box pl={16} pt={4} pb={4}>
          <Stack horizontal align="center" gap="s">
            <Text font="brand-display-5" color="white" as="span">
              AWS ACCOUNT PORTAL
            </Text>
          </Stack>
        </Box>
      </nav>

      <Box pt={80} pl={16} pr={16}>
        <ErrorBoundary>
          {children}
        </ErrorBoundary>
      </Box>
    </>
  );
}
